import { endpoints } from "../config";
import { getData } from "./api-utils";

const getPdd = async (tehmeId) => {
  return await getData(endpoints.pdd + `?theme=${tehmeId}`);
};

export { getPdd };
